import React from 'react';
import { Dialog, Button, Flex, Text, Box, Separator } from '@radix-ui/themes';
import { X, Pill, CheckSquare } from 'lucide-react';

const MedicationPopup = ({ isOpen, onClose, medicationData, loading, error }) => {
  // Determine the type and heading based on first item
  const getDisplayInfo = () => {
    if (!medicationData || medicationData.length === 0) {
      return { heading: 'Details', icon: null, isMedication: true };
    }
    
    const firstItem = medicationData[0];
    const isMedication = firstItem.type === 1;
    
    return {
      heading: isMedication ? 'Medication Details' : 'Task Details',
      icon: isMedication ? <Pill size={20} /> : <CheckSquare size={20} />,
      isMedication
    };
  };

  const displayInfo = getDisplayInfo();

  const renderMedicationList = () => {
    return medicationData.map((item, index) => (
      <Box key={index} className="p-4 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition-colors">
        <Flex direction="column" gap="3">
          <Flex justify="between" align="center">
            <Text weight="medium" className="text-gray-700">Medication:</Text>
            <Text weight="bold" className="text-gray-900">{item.medication || 'N/A'}</Text>
          </Flex>
          <Flex justify="between" align="center">
            <Text weight="medium" className="text-gray-700">Dosage:</Text>
            <Text className="text-gray-900">{item.dosage || 'N/A'}</Text>
          </Flex>
          <Flex justify="between" align="center">
            <Text weight="medium" className="text-gray-700">Root:</Text>
            <Text className="text-gray-900">{item.root || 'N/A'}</Text>
          </Flex>
        </Flex>
      </Box>
    ));
  };

  const renderTaskList = () => {
    return medicationData.map((item, index) => (
      <Box key={index} className="p-4 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition-colors">
        <Flex justify="between" align="center">
          <Text weight="medium" className="text-gray-700">Task:</Text>
          <Text weight="bold" className="text-gray-900">{item.medication || 'N/A'}</Text>
        </Flex>
      </Box>
    ));
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Content maxWidth="500px" className="p-6">
        <Flex justify="between" align="center" className="mb-4">
          <Flex align="center" gap="2">
            {displayInfo.icon && (
              <Box className={displayInfo.isMedication ? "text-blue-600" : "text-green-600"}>
                {displayInfo.icon}
              </Box>
            )}
            <Dialog.Title size="5" weight="bold" className="text-gray-900">
              {displayInfo.heading}
            </Dialog.Title>
          </Flex>
          <Button 
            variant="ghost" 
            size="2" 
            onClick={onClose}
            className="hover:bg-gray-100 rounded-full p-2"
          >
            <X size={18} />
          </Button>
        </Flex>

        <Separator className="mb-4" />

        <Box className="max-h-96 overflow-y-auto">
          {loading && (
            <Flex justify="center" align="center" className="py-8">
              <Text>Loading details...</Text>
            </Flex>
          )}

          {error && (
            <Box className="p-4 bg-red-50 border border-red-200 rounded-lg">
              <Text color="red" size="2">
                Error loading details: {error}
              </Text>
            </Box>
          )}

          {!loading && !error && medicationData && medicationData.length > 0 && (
            <Flex direction="column" gap="3">
              {displayInfo.isMedication ? renderMedicationList() : renderTaskList()}
            </Flex>
          )}

          {!loading && !error && (!medicationData || medicationData.length === 0) && (
            <Flex justify="center" align="center" className="py-8">
              <Text className="text-gray-500">No details available</Text>
            </Flex>
          )}
        </Box>

        <Separator className="my-4" />

       
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default MedicationPopup;